import { TextValue } from '@shared/interfaces';

export const statusDefaultTextValue: TextValue = { text: 'status.all', value: -1 };
